//Use this file to configure server ip adress

const serverIp = process.env.REACT_APP_BACKEND_URL;

export function getServerIp() {
  return serverIp;
}
